import { Button } from '@forgeglobal/design-framework';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import { Beneficiary } from '@tcs/client-portal-api/types/Beneficiary';
import DialogLayout from '@tcs/client-portal-common/components/organisms/DialogLayout';
import useBeneficiariesMutation from '@tcs/client-portal-common/hooks/useBeneficiariesMutation';
import useExitPrompt from '@tcs/client-portal-common/hooks/useExitPrompt';
import useMaritalStatus from '@tcs/client-portal-common/hooks/useMaritalStatus';
import { useState } from 'react';
import BeneficiariesListForm from './forms/BeneficiariesListForm';
import useStyles from './style';

interface BeneficiariesDetailProps {
  contingentBeneficiaries: Beneficiary[];
  primaryBeneficiaries: Beneficiary[];
  setShowDetails: (showDetails: boolean) => void;
  name: string;
  accountNumber: string;
}

const BeneficiariesDetail = ({
  primaryBeneficiaries,
  contingentBeneficiaries,
  setShowDetails,
  name,
  accountNumber,
}: BeneficiariesDetailProps) => {
  const classes = useStyles();

  const [showExitPrompt, setShowExitPrompt] = useExitPrompt(false);

  const [showExitConfirm, setShowExitConfirm] = useState(false);

  const mutateBeneficiaries = useBeneficiariesMutation(accountNumber);

  const { data: maritalStatus } = useMaritalStatus(accountNumber);

  const handleOnSubmit = async (data) => {
    await mutateBeneficiaries.mutateAsync({
      primaryBeneficiaries: data.primaryBeneficiaries || [],
      contingentBeneficiaries: data.contingentBeneficiaries || [],
      ...data,
      maritalStatus:
        data.maritalStatus === maritalStatus ? null : data.maritalStatus,
    });
    setShowDetails(false);
  };

  const handleOnCancel = () => {
    if (showExitPrompt) {
      setShowExitConfirm(true);
      return;
    }

    setShowDetails(false);
  };

  return (
    <DialogLayout setShowDialog={handleOnCancel} shouldShowUser name={name}>
      <BeneficiariesListForm
        accountNumber={accountNumber}
        primaryBeneficiaries={primaryBeneficiaries}
        contingentBeneficiaries={contingentBeneficiaries}
        maritalStatus={maritalStatus}
        onSubmit={handleOnSubmit}
        onCancel={handleOnCancel}
        setShowExitPrompt={setShowExitPrompt}
      />
      <Dialog open={showExitConfirm} maxWidth="sm" fullWidth>
        <DialogContent className={classes.dialogContent}>
          Are you sure you want to exit? <br />
          You have unsaved changes that will be lost
        </DialogContent>
        <DialogActions className={classes.dialogActions}>
          <Button
            variant="outlined"
            onClick={() => {
              setShowExitConfirm(false);
            }}>
            Cancel
          </Button>
          <Button
            onClick={() => {
              setShowExitConfirm(false);
              setShowDetails(false);
            }}>
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    </DialogLayout>
  );
};

export default BeneficiariesDetail;
